import { Grid } from '@mui/material';
import { IEditableLegalClient } from '../../../Interfaces/IEditLegalClient';
import { PostcodeField } from './fields/Postcode/PostcodeField';
import { StreetField } from './fields/Street/StreetField';
import { StreetAdditionalField } from './fields/StreetAdditional/StreetAdditionalField';
import { StreetNumberField } from './fields/StreetNumber/StreetNumberField';

interface IUpdateAddressFormProps {
  requireStreet?: boolean;
  requireStreetNumber?: boolean;
}

export function UpdateAddressForm({
  requireStreet = false,
  requireStreetNumber = false,
}: IUpdateAddressFormProps) {
  return (
    <Grid container spacing={2} pt={0.75}>
      <Grid item xs={8}>
        <StreetField<IEditableLegalClient>
          name='AddressArray.0.Street'
          required={requireStreet}
        />
      </Grid>
      <Grid item xs={4}>
        <StreetNumberField<IEditableLegalClient>
          name='AddressArray.0.Number'
          required={requireStreetNumber}
        />
      </Grid>
      <Grid item xs={12}>
        <StreetAdditionalField<IEditableLegalClient>
          name='AddressArray.0.StreetAdditional'
          required={false}
        />
      </Grid>
      <Grid item xs={12}>
        <PostcodeField<IEditableLegalClient> name='AddressArray.0.idPostcode' />
      </Grid>
    </Grid>
  );
}
